const getters = {
    visitedViews: state => state.app.visitedViews,
    taskStatus:state => state.app.taskStatus,
    sidebar: state => state.app.sidebar,
    token: state => state.user.token,
    name: state => state.user.name,
    roles: state => state.user.roles,
    setting: state => state.user.setting,
    ticket:state => state.user.ticket,
    permission_routers: state => state.permission.routers,
    addRouters: state => state.permission.addRouters,
    routerLoadDone:state => state.permission.routerLoadDone
};
export default getters



// WEBPACK FOOTER //
// ./src/other/store/getters.js